import { useTranslation } from 'react-i18next'

import Text from '../../../../../Text'
import { APPLICANT_CHECKLIST_COLUMN_TITLE_KEYS } from '../ApplicantDocumentChecklist.constants'

import * as styles from './ApplicantDocumentChecklistHead.module.css'

function ApplicantDocumentChecklistHead() {
  const { t } = useTranslation()

  return APPLICANT_CHECKLIST_COLUMN_TITLE_KEYS.map(titleKey => (
    <Text isSecondary className={styles.title} key={titleKey}>
      {t(titleKey)}
    </Text>
  ))
}

export default ApplicantDocumentChecklistHead
